import "@gettactic/components";
import { i18n } from "@gettactic/components/src/lib/i18n";
export { i18n };
export { i18n as lang };
